var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AspectRatioWrapper',{attrs:{"ratio":[6, 4]}},[_c('ResponsiveImage',{staticClass:"gallery-item",attrs:{"image-versions":_vm.featuredImageVersions,"description":_vm.description,"width":_vm.width},nativeOn:{"click":function($event){return _vm.onItemClick.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }